module.exports = __webpack_public_path__ + "42c6171657ded4038fd4095510b0f2b5.svg";